import { inject, Injectable } from '@angular/core';
import { Tenant } from '../../contracts/models/tenant.model';
import { map } from 'rxjs/operators';
import { UserDto, User } from '../../contracts/models/user.model';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiResult } from '../../contracts/types/api-response.type';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Storage } from '../../utils/storage.class';
@Injectable({ providedIn: 'root' })
export class TenantLocalService {

    private storage = inject(Storage);

    private readonly TENANT_KEY = 'TENANT';
    private readonly SLUG_TENANT_KEY = 'SLUG_TENANT';

    private readonly USUARIOS_KEY = 'USUARIOS_LIMIT';
    private readonly PERSONAS_KEY = 'PERSONAS_LIMIT';
    private readonly CAMPANIES_KEY = 'CAMPANIES_LIMIT';
    private readonly CLIENTES_KEY = 'CLIENTES_LIMIT';
    private readonly MEDIOS_KEY = 'MEDIOS_LIMIT';
    private readonly PLAN_MEDIOS_KEY = 'PLAN_MEDIOS_LIMIT';
    private readonly NOTAS_PRENSA_KEY = 'NOTAS_PRENSA_LIMIT';

    private tenantSlugAuth = new BehaviorSubject<string | null>(
        this.storage.getItem(this.SLUG_TENANT_KEY)
    );
    private tenantAuth = new BehaviorSubject<any>(
        this.storage.getItem(this.TENANT_KEY)
    );

    public tenantSlug$ = this.tenantSlugAuth.asObservable();
    public tenant$ = this.tenantAuth.asObservable();

    public setTenantSlug(tenantId: string): void {
        this.storage.setItem(this.SLUG_TENANT_KEY, tenantId);
        this.tenantSlugAuth.next(tenantId);
    }

    get tenantSlug(): string | null {
        return this.tenantSlugAuth.value;
    }

    public setTenant(tenant: Tenant):void {
        this.storage.setItem(this.TENANT_KEY, tenant);
        this.tenantAuth.next(tenant);
    }

    get tenant(): Tenant {
        return this.tenantAuth.value;
    }

    setTotalUsuarios(usuarios: any): void {
        this.storage.setItem(this.USUARIOS_KEY, usuarios);
    }

    getTotalUsuarios(): any | null {
        return this.storage.getItem(this.USUARIOS_KEY);
    }

    setTotalPersonas(personas: any): void {
        this.storage.setItem(this.PERSONAS_KEY, personas);
    }

    getTotalPersonas(): any | null {
        return this.storage.getItem(this.PERSONAS_KEY);
    }

    setTotalCampanies(campanies: any): void {
        this.storage.setItem(this.CAMPANIES_KEY, campanies);
    }

    getTotalCampanies(): any | null {
        return this.storage.getItem(this.CAMPANIES_KEY);
    }

    setTotalClientes(clientes: any): void {
        this.storage.setItem(this.CLIENTES_KEY, clientes);
    }

    getTotalClientes(): any | null {
        return this.storage.getItem(this.CLIENTES_KEY);
    }

    setTotalMedios(medios: any): void {
        this.storage.setItem(this.MEDIOS_KEY, medios);
    }

    getTotalMedios(): any | null {
        return this.storage.getItem(this.MEDIOS_KEY);
    }

    setTotalPlanMedios(planmedios: any): void {
        this.storage.setItem(this.PLAN_MEDIOS_KEY, planmedios);
    }

    getTotalPlanMedios(): any | null {
        return this.storage.getItem(this.PLAN_MEDIOS_KEY);
    }

    setTotalNotasdePrensa(notasprensa: any): void {
        this.storage.setItem(this.NOTAS_PRENSA_KEY, notasprensa);
    }

    getTotalNotasdePrensa(): any | null {
        return this.storage.getItem(this.NOTAS_PRENSA_KEY);
    }
}

